import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Context from '../../provider';
import React, { useContext } from 'react';

export default function LoadingBackdrop() {
  const { isBackdropLoading } = useContext(Context);

  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isBackdropLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}